import Header from './components/header/Header';
// import Home from './pages/Home';
// import Projects from './pages/Projects'
// import Contact from './pages/Contact';
// import About from './pages/About';
import Footer from './pages/Footer';

import Construction from './pages/construction';


const App = () => (
      <>
        <Header />
        {/* <Home />
        <About />
        <Projects />
        <Contact /> */}
        <Construction />
        <Footer />
      </>
);

export default App;
